module.exports = "/images/image.png?ad3feb5ef816d6bf17a9eb3bdf1624ee";